import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeam } from "../../Redux/WebsiteSlice";
import { useBookingModal } from "../../context/BookingModalContext";
import "./OurTeam.scss";

const OurTeam = () => {
  const dispatch = useDispatch();
  const team = useSelector((state) => state.website.team);
  const { openModal } = useBookingModal();

  useEffect(() => {
    dispatch(fetchTeam());
  }, [dispatch]);

  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    if (url.startsWith("/uploads/")) {
      return "https://api-test.swifttoolskit.cloud/api" + url;
    }
    return url;
  };

  return (
    <div className="page-our-team">
      <div className="page-hero">
        <div className="page-hero__content">
          <span className="small__text">MEET THE TEAM</span>
          <h1 className="headline__text">
            Our <span>Expert Team</span>
          </h1>
          <p className="page-hero__subtitle">
            Our dedicated team of healthcare professionals is committed to providing the highest quality, personalised care.
          </p>
        </div>
      </div>

      <section className="compSection comp_our_team">
        <div className="custom_container">
          <div className="row row--team">
            {team && team.length > 0 ? (
              <div className="team__grid">
                {team.map((member) => (
                  <div key={member._id} className="team__card">
                    <div className="team__card__image">
                      {member.image ? (
                        <img
                          src={getImageUrl(member.image)}
                          alt={member.name}
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.parentElement.classList.add(
                              "team__card__image--placeholder"
                            );
                          }}
                        />
                      ) : (
                        <div className="team__card__placeholder">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="team__card__content">
                      <h4 className="team__card__name">{member.name}</h4>
                      {member.role && (
                        <p className="team__card__role">{member.role}</p>
                      )}
                      {member.bio && (
                        <p className="team__card__bio">{member.bio}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="team-empty">
                <p>Team information coming soon.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <div className="team-cta">
        <div className="team-cta__inner">
          <h2>Ready to book with one of our team?</h2>
          <p>Our practitioners are here to help you get back to feeling your best.</p>
          <button
            type="button"
            onClick={() => setTimeout(openModal, 0)}
            className="site__button site__button_style--solid site__button_shape--default"
          >
            <span className="text">Book an Appointment</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
